import React from 'react';
import { PropTypes } from 'prop-types';
import { Feedback, Spacer } from '@ontruck/orc';
import LoadSpinner from 'components/LoadSpinner';
import Header from './components/Header';
import PricingDetail from './components/PricingDetail';
import { useTranslation } from 'react-i18next';
import { useOrder } from 'hooks/useOrders';
import { history } from 'state/store';
import routes from 'utils/routes';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import ModalSummary from 'components/orders/OrderDetail/components/ModalSummary';

const RecurringOrderDetail = ({ className, match }) => {
  const { orderId } = match?.params;
  const { isLoading, order, error } = useOrder(orderId, true);
  const { t } = useTranslation('Recurring');
  const billingPhone = useSelector(settingsSelectors.getFinancePhone);

  // --- Renders ---
  if (error) {
    history.push(`${routes.orders.active}/`);
    return null;
  }

  if (isLoading) {
    return (
      <Spacer
        pTop="L"
        pBottom="L"
        data-testid="recurring-order-detail--loading"
      >
        <LoadSpinner />
      </Spacer>
    );
  }

  if (!isLoading && !order) {
    return null;
  }

  return (
    <div className={className} data-testid="recurring-order-detail">
      <Header orderId={orderId} />

      <div className="recurring-summary-container ">
        <div className="summary-item">
          <ModalSummary orderId={orderId} isRecurring />
        </div>
      </div>

      <div>
        <PricingDetail extras={order.extras} />
      </div>

      <div className="feedbackbar-wrapper">
        <Feedback skin="important" size="wideS">
          {t('detail.cancel_recurring_order', { billingPhone })}
        </Feedback>
      </div>
    </div>
  );
};

RecurringOrderDetail.propTypes = {
  className: PropTypes.string,
  match: PropTypes.object,
};

export default RecurringOrderDetail;
